import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import ContentOverviewHeaderContainer from 'src/components/contentOverview/_contentOverviewHeaderContainer/ContentOverviewHeaderContainer';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

import { VideoItem } from './VideoItem';

import styles from './VideoPlayer.module.css';

type VideoProps = {
	video: VideoItem;
};

export default function VideoPlayer(props: VideoProps): JSX.Element {
	const isEditing = IsSitecoreEditing();

	if (!isEditing && (!props.video || !props.video.fields)) {
		return <></>;
	} else if (isEditing && (!props.video || !props.video.fields)) {
		return <EditorHelp text="Add a datasource for this video component" />;
	}

	const videoTitle = props.video?.fields?.VideoHeading?.value || props.video?.fields?.ResourceTitle?.value || '';

	const youtubeId = props.video?.fields?.YoutubeUrl?.value ? props.video?.fields.YoutubeUrl.value.split('/').slice(-1)[0] : null;
	const vimeoId = props.video.fields?.VimeoUrl?.value ? props.video?.fields.VimeoUrl.value.split('/').slice(-1)[0] : null;

	const resourceVideoUrl = props.video?.fields?.VideoUrl?.value?.match(/src="([^"]+)"/);

	let embeddedVideoUrl = '';

	if (youtubeId) {
		embeddedVideoUrl = `https://www.youtube.com/embed/${youtubeId}`;
	} else if (vimeoId) {
		embeddedVideoUrl = `https://player.vimeo.com/video/${vimeoId}`;
	} else if (resourceVideoUrl) {
		embeddedVideoUrl = resourceVideoUrl[1];
	}

	return (
		<div className={`${styles.videoContainer} padX padY`} id="videoContainer">
			<ContentOverviewHeaderContainer
				header={videoTitle}
				subHeader={props.video?.fields?.VideoSubheading?.value}
				description={props.video?.fields?.VideoDescription?.value}
			/>

			{embeddedVideoUrl && (
				<iframe src={embeddedVideoUrl} allow="autoplay; fullscreen" allowFullScreen className={styles.iframe} title={videoTitle} />
			)}
		</div>
	);
}
